export class Translation {
  englishValue: string;
  key: string;
  translatedValue: string;
  newValue: string;
  isEditing: boolean;
  isItemLoading: boolean;

  constructor(key?: string, englishValue?: string, translatedValue?: string) {
    this.key = key;
    this.englishValue = englishValue;
    this.translatedValue = translatedValue;
  }
}
